<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat>
      <v-card-title class="background secondarytext--text">
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form ref="form" v-model="valid">
        <v-card-text>
          <v-textarea
            flat
            solo
            v-model="talkingPoint.text"
            label="Write your talking point here"
            :rules="[$rules.required]"
            v-if="dialog"
            autofocus
          >
          </v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-2">
          <v-row dense>
            <v-col cols="auto" class="my-auto">
              <v-checkbox
                v-model="talkingPoint.isUrgent"
                label="Mark Urgent"
                color="performance"
                hide-details
                class="pa-0 ma-0"
              ></v-checkbox>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-btn color="performance" :loading="saving" @click="save">
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "EditTalkingPointDialog",
  components: {},
  props: {},
  data: () => ({
    dialog: false,
    valid: false,
    saving: false,
    talkingPoint: {}
  }),
  watch: {},
  computed: {
    title() {
      return this.talkingPoint.id ? "Edit talking point" : "Add talking point";
    },
    ...mapGetters({ checkin: "checkin/checkin", profile: "profile/profile" })
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("checkin/saveTalkingPoint", this.talkingPoint)
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess("Talking Point saved");
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving your talking point."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    showDialog(talkingPoint) {
      this.dialog = true;
      this.talkingPoint = Object.assign({}, talkingPoint);
    }
  }
};
</script>
